import { render, staticRenderFns } from "./SuggestedUserStoriesDialog.vue?vue&type=template&id=e1555694&scoped=true"
import script from "./SuggestedUserStoriesDialog.vue?vue&type=script&lang=js"
export * from "./SuggestedUserStoriesDialog.vue?vue&type=script&lang=js"
import style0 from "./SuggestedUserStoriesDialog.vue?vue&type=style&index=0&id=e1555694&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1555694",
  null
  
)

export default component.exports